module.exports = "<aside class=sidebar> <app-nav></app-nav> </aside> ";